import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import SessionLoader from "./SessionLoader";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, authLoading } = useAuth();

  if (authLoading) return <SessionLoader />;

  if (isAuthenticated) {
    return <Navigate to="/ProfileDash" replace />;
  }

  return children;
};

export default PublicRoute;
